import { Monitor } from 'lucide-react';
import { EVENT_TYPE_ICON } from './liveScreenUtils';

export interface BrowserMockupProps {
  domain: string | null;
  pageTitle?: string | null;
  url?: string | null;
  eventType: string | null;
  isOnline: boolean;
  dm: boolean;
  compact: boolean;
}

/**
 * Simulated browser chrome used when no real screenshot is available.
 * Shared by teacher and school-admin live-screen views.
 */
export function BrowserMockup({ domain, pageTitle, url, eventType, isOnline, dm, compact }: BrowserMockupProps) {
  const displayDomain = domain || 'No activity';
  const displayPage = pageTitle || url || '';

  return (
    <div className={`rounded-lg overflow-hidden flex flex-col h-full ${dm ? 'bg-slate-900' : 'bg-slate-100'}`}>
      {/* Browser chrome bar */}
      <div className={`px-2 py-1.5 flex items-center gap-2 shrink-0 ${dm ? 'bg-slate-700' : 'bg-slate-200'}`}>
        <div className="flex items-center gap-1">
          <div className="h-2 w-2 rounded-full bg-red-400" />
          <div className="h-2 w-2 rounded-full bg-amber-400" />
          <div className="h-2 w-2 rounded-full bg-emerald-400" />
        </div>
        <div className={`flex-1 rounded px-2 py-0.5 text-xs truncate ${dm ? 'bg-slate-800 text-slate-400' : 'bg-white text-slate-500'}`}>
          {domain ? `🔒 ${domain}` : '—'}
        </div>
      </div>

      {/* Content area */}
      <div className={`flex-1 flex flex-col items-center justify-center p-3 text-center ${dm ? 'text-slate-400' : 'text-slate-500'}`}>
        {isOnline ? (
          <>
            <span className="text-3xl mb-2">{EVENT_TYPE_ICON[eventType || ''] || '🌐'}</span>
            <p className={`text-xs font-semibold truncate w-full ${dm ? 'text-slate-300' : 'text-slate-700'}`}>
              {displayDomain}
            </p>
            {!compact && displayPage && (
              <p className="text-xs mt-1 truncate w-full opacity-70">{displayPage}</p>
            )}
          </>
        ) : (
          <>
            <Monitor className="h-8 w-8 opacity-30 mb-2" />
            <p className="text-xs opacity-50">Offline</p>
          </>
        )}
      </div>
    </div>
  );
}
